import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { i18nReady } from './i18n';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');

function render() {
  if (rootElement.hasChildNodes()) {
    // Pre-rendered HTML exists — hydrate it
    hydrateRoot(
      rootElement,
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } else {
    // No pre-rendered HTML — normal client render
    createRoot(rootElement).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  }
}

i18nReady.finally(render);

// Web Vitals describe a real visitor's session. Skip them while react-snap
// pre-renders: the metrics are meaningless there, and web-vitals uses syntax the
// bundled Chromium does not support, which fails the production build.
const isPrerender = typeof navigator !== 'undefined' && /ReactSnap/i.test(navigator.userAgent);

if (!isPrerender) {
  reportWebVitals(({ name, delta, id }) => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', name, {
        event_category: 'Web Vitals',
        event_label: id,
        value: Math.round(name === 'CLS' ? delta * 1000 : delta),
        non_interaction: true,
      });
    }
  });
}
